import { ParametrosPaginacao } from '../model/interface/parametros-paginacao';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Assessor } from '../model/assessor';
import { ListaPaginada } from '../model/lista-paginada';
import { RespostaHttp } from '../model/resposta-http';
import { InvestidorAssessorado } from '../model/investidor-assessorado';

@Injectable({
  providedIn: 'root'
})
export class AssessorCoreService{

  constructor(private http: HttpClient) { }

  postAssessor(assessor: Assessor): Observable<RespostaHttp<Assessor>> {
    return this.http.post<RespostaHttp<Assessor>>(`${environment.apiUrl}/assessores`, assessor).pipe(take(1));
  }

  getAssessores(paginacao: ParametrosPaginacao): Observable<RespostaHttp<ListaPaginada<Assessor>>> {
    let url: string;
    if (paginacao.tamanhoPagina != null && paginacao.indicePagina != null) {
      url = `${environment.apiUrl}/assessores?size=${paginacao.tamanhoPagina}&page=${paginacao.indicePagina}`;
    } else if (paginacao.tamanhoPagina != null) {
      url = `${environment.apiUrl}/assessores?size=${paginacao.tamanhoPagina}`;
    }
    return this.http.get<RespostaHttp<ListaPaginada<Assessor>>>(url).pipe(take(1));
  }

  getAssessorPorUuid(assessorUuid: string): Observable<RespostaHttp<Assessor>> {
    return this.http.get<RespostaHttp<Assessor>>(`${environment.apiUrl}/assessores/${assessorUuid}`).pipe(take(1));
  }

  getAssessorPorCodigoPrimecap(codigoPrimecap: string): Observable<RespostaHttp<Assessor>> {
    return this.http.get<RespostaHttp<Assessor>>(`${environment.apiUrl}/assessores/primecap/${codigoPrimecap}`).pipe(take(1));
  }

  getAssessorPorNome(assessorNome: string, paginacao: ParametrosPaginacao): Observable<RespostaHttp<ListaPaginada<Assessor>>> {
    let url: string;
    if (assessorNome == '') {
      url = `${environment.apiUrl}/assessores?size=${paginacao.tamanhoPagina}&page=${paginacao.indicePagina}`;
    } else {
      url = `${environment.apiUrl}/assessores/filtros?nome=${assessorNome}&size=${paginacao.tamanhoPagina}&page=${paginacao.indicePagina}&sort=nome`;
    }
    return this.http.get<RespostaHttp<ListaPaginada<Assessor>>>(url).pipe(take(1));
  }

  getInvestidoresPush(assessorUuid: string, paginacao: ParametrosPaginacao): Observable<RespostaHttp<ListaPaginada<InvestidorAssessorado>>> {
    let url: string = `${environment.apiUrl}/assessores/${assessorUuid}/dashboards/lista-investidores-push`;
    if (paginacao.tamanhoPagina != null && paginacao.indicePagina != null) {
      url = url.concat(`?size=${paginacao.tamanhoPagina}&page=${paginacao.indicePagina}`);
    } else if (paginacao.tamanhoPagina != null) {
      url = url.concat(`?size=${paginacao.tamanhoPagina}`);
    }
    return this.http.get<RespostaHttp<ListaPaginada<InvestidorAssessorado>>>(url);
  }

  putAssessor(assessor: Assessor): Observable<RespostaHttp<Assessor>> {
    return this.http.put<RespostaHttp<Assessor>>(`${environment.apiUrl}/assessores/${assessor.uuid}`, assessor).pipe(take(1));
  }

  deleteAssessor(assessorUuid: string): Observable<RespostaHttp<Assessor>> {
    return this.http.delete<RespostaHttp<Assessor>>(`${environment.apiUrl}/assessores/${assessorUuid}`).pipe(take(1));
  }
}
